module.exports = __webpack_public_path__ + "img/nova-96.4357863c.png";